import base64 from 'base-64';
import fetchMeAsync from './helpers/fetchMeAsync';
import fetchIpAsync from './helpers/fetchIpAsync';
import signInAsync from './helpers/signInAsync';
import { logAsync } from 'helpers/elogAsync';
import fetchSubjectId from './helpers/fetchSubjectId';
import Promise from 'bluebird';
import socket from 'helpers/esocket';
import clientId from 'clientId';
import _ from 'lodash';
import {Modal} from 'antd';

function commonLogin() {
  fetchMeAsync()
  .catch(() => {
    if (!localStorage.isAutoSignIn) {
      throw new Error('need login');
    }
    return signInAsync({
      email: localStorage.email,
      password: base64.decode(localStorage.password),
    })
    .then(fetchMeAsync);
  })
  .catch(() => {
    const path = location.hash && location.hash.replace('#', '');
    location.replace('/login.html?path=' + path);
  })
  .then(function() {
    logAsync({
      type: "sPOP-login",
    })
    require.ensure([], function(require) {
      require('./app');
    });
  });
}

//固定账号，验证IP自动登录机制
function checkIpLogin() {
  localStorage.email = "spopguest@hksyu.edu";
  localStorage.password = base64.encode("spop@hksyu");
  delete localStorage.isAutoSignIn;
  signInAsync({
    email: "spopguest@hksyu.edu",
    password: "spop@hksyu",
  })
  .then(function() {
    fetchMeAsync()
    .then(function() {
      logAsync({
        type: "sPOP-login",
      })
      const me = JSON.parse(localStorage.me);
      let socketRoom = `${clientId}-Login-${me.group_id}`;
      if (!_.isEmpty(_.get(me.permission, 'concurrentLogin.roleIds'))) {
        socketRoom = `${socketRoom}-${_.join(_.get(me.permission, 'concurrentLogin.roleIds'), '-')}`
      }
      socket.emit('clientID', socketRoom, (n) => {
        if (n >= _.get(me, 'permission.concurrentLogin.quota')) {
          Modal.info({
            title: '暫無法登入',
            content: '當前在線人數已滿，請稍後再試',
            okText: '確定',
            onOk: () => {
              localStorage.clear()
              location.replace('/login.html');
            }
          });
        }
      })
      require('./app');
    })
  });
}

function requireApp() {
  require('./app');
}


if (window.location.host.split('.')[0] == "0-spop-hksyu") {
  checkIpLogin();
} else {
  commonLogin();
}



/** WEBPACK FOOTER **
 ** ./src/app/index.js
 **/